import { render } from "./color_list.vue?vue&type=template&id=297647c4"
import script from "./color_list.vue?vue&type=script&lang=js"
export * from "./color_list.vue?vue&type=script&lang=js"

import exportComponent from "/opt/build/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__